/** Full Redux store wipe (used on logout). */
export const APP_CLEAR_STORE = '@@app/CLEAR_STORE';
